import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@app/_services/auth/auth.service';
import { UserAuthDto } from '@app/shared/model/user.model';

@Component({
  selector: 'app-auth-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-dashboard.component.html',
  styleUrl: './auth-dashboard.component.scss'
})
export class AuthDashboardComponent implements OnInit {
  currentUser: UserAuthDto | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserValue();
    console.log('Dashboard loaded. Current user:', this.currentUser);
  }
}
